export const chapterContent = {
  id: 1,
  comicId: 1,
  comicTitle: '洞洞杂货铺',
  chapterNumber: 186,
  chapterTitle: '第186话 门后的世界',
  prevChapter: 185,
  nextChapter: 187,
  totalChapters: 186,
  content: `<h2>第186话 门后的世界</h2>

<p>夜色如墨，洞洞杂货铺的暖黄色灯光在巷子里显得格外温暖。</p>

<p>林洞洞正趴在柜台上打盹，手里还握着半块没吃完的桂花糕。挂在门上的铜铃忽然轻轻响了一声——有客人来了。</p>

<p>"欢迎光临——"林洞洞揉了揉眼睛，抬起头来。</p>

<p>站在门口的是一位穿着白色连衣裙的少女，她的头发湿漉漉的，像是刚从水里捞出来一样。但外面并没有下雨。</p>

<p>"请问……这里什么都能买到吗？"少女的声音很轻，像是隔着一层水雾传来。</p>

<p>林洞洞看着她，目光落在她脚边那一小滩不断扩大的水渍上。他没有露出惊讶的表情，只是微微一笑："那要看你想买什么了，姐姐。"</p>

<p>少女犹豫了一下，从口袋里摸出一枚湿透了的硬币，轻轻放在柜台上。</p>

<p>"我想……买回我的声音。"</p>

<p>林洞洞拿起那枚冰凉的硬币，翻过来，背面刻着一行小字：<em>深海之心，无声之约</em>。</p>

<p>他收起笑容，认真地看着少女："这个，可不容易呢。"</p>

<p>"我知道。"少女低下头，"但我没有别的办法了。他们说这里什么都能买到，只要……只要付出足够的代价。"</p>

<p>林洞洞从柜台下面拿出一本厚厚的册子，封面上用毛笔写着四个字：<strong>杂货名录</strong>。他翻到某一页，指着上面一行字说：</p>

<p>"找回失去的声音——代价是，一段你最重要的记忆。成交吗？"</p>

<p>少女的手指紧紧攥住了裙摆。一段最重要的记忆？那会是什么？是和妹妹一起在海边捡贝壳的午后？还是第一次登上舞台、在聚光灯下唱歌的那个夜晚？</p>

<p>她闭上眼睛，深吸了一口气："……成交。"</p>

<p>林洞洞没有立刻动手。他看着少女微微颤抖的肩膀，忽然问："为什么要找回声音？"</p>

<p>少女睁开眼睛，眼眶已经红了："因为……我的妹妹生病了，她最喜欢听我唱歌。医生说她可能……可能撑不过这个冬天了。我想在她还能听到的时候，再给她唱一首歌。就一首。"</p>

<p>杂货铺里安静了下来，只有老旧的挂钟在墙上滴滴答答地走着。</p>

<p>林洞洞沉默了很久，然后把那本厚厚的册子合上了。</p>

<p>"姐姐，"他说，"这单生意，我不做了。"</p>

<p>少女愣住了："可是——"</p>

<p>"但是，"林洞洞打断她，从另一个抽屉里拿出一个小小的玻璃瓶，里面装着一些闪闪发光的液体，"这个送你。每天晚上滴一滴在喉咙上，连续七天。不能多，也不能少。"</p>

<p>"这是什么？"</p>

<p>"朝露。"林洞洞笑了笑，"每天清晨第一缕阳光照射到花瓣上的露水，我收集了大半年才攒够这一小瓶。它不能让你恢复声音，但是……"他顿了顿，"它可以让你的妹妹，在每个夜晚都梦到你唱歌。"</p>

<p>少女接过玻璃瓶，双手微微颤抖："那代价呢？"</p>

<p>林洞洞想了想，指了指桌上剩下的半块桂花糕："就这个吧。正好我今晚没吃饱。"</p>

<p>少女愣住了，然后笑了。那是她失去声音以来，露出的第一个笑容。</p>

<p>她拿起那半块桂花糕，轻轻放在林洞洞的手心里。</p>

<p>"谢谢你，洞洞。"她用口型说。</p>

<p>铜铃再次响起，少女的身影消失在夜色中。柜台上那滩水渍不知何时已经干了，只留下一小片淡淡的盐渍，在灯光下闪着微微的光。</p>

<p>林洞洞咬了一口桂花糕，翻开杂货名录，在这一页的最下面，用小字写了一行备注：</p>

<p><em>——交易未完成。但似乎，也不算亏。</em></p>

<p>窗外的月亮很圆。洞洞杂货铺的灯光，一如既往地温暖着这条安静的巷子。</p>

<p>而在城市的另一头，病房的窗前，一个小女孩在梦中露出了甜甜的笑容。她梦见了姐姐站在海边，海风吹起她的长发，她张开嘴，唱了一首好美好美的歌。</p>

<p>（本章完）</p>
`,
  prevChapterTitle: '第185话 雨夜的访客',
  nextChapterTitle: '第187话 旧照片的秘密',
};

export const chapterList = [
  { number: 186, title: '第186话 门后的世界', date: '2026-08-03' },
  { number: 185, title: '第185话 雨夜的访客', date: '2026-08-01' },
  { number: 184, title: '第184话 镜中的倒影', date: '2026-07-30' },
  { number: 183, title: '第183话 猫的报恩', date: '2026-07-28' },
  { number: 182, title: '第182话 消失的第七天', date: '2026-07-26' },
  { number: 181, title: '第181话 月光下的约定', date: '2026-07-24' },
  { number: 180, title: '第180话 老钟的秘密', date: '2026-07-22' },
  { number: 179, title: '第179话 来自远方的信', date: '2026-07-20' },
  { number: 178, title: '第178话 夏天的尾巴', date: '2026-07-18' },
  { number: 177, title: '第177话 萤火虫之夜', date: '2026-07-16' },
];